export default __webpack_public_path__ + "fd70b1138d064d290e940b1a3ba48b44.jpeg";